<div class="container">
    <h2 class="row">User details</h2>
    <div class="mat-elevation-z2 panel">
        <mat-spinner *ngIf="loading"></mat-spinner>
        <div *ngIf="!loading" class="wrapper">
            <div class="user">
                <img class="avatar" [src]="user.avatar" alt="">
                <h3>{{user.name}}</h3>
                <p>
                    {{user.desc}}
                </p>
            </div>
            <div class="details">
                <form>
                    <mat-form-field appearance="outline">
                        <mat-label>Email</mat-label>
                        <input disabled name="email" [(ngModel)]="user.email" type="email" matInput
                               placeholder="red@like.roses"
                               autocomplete="off">
                        <mat-icon matSuffix>alternate_email</mat-icon>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Description</mat-label>
                        <input maxlength="50" name="desc" [(ngModel)]="user.desc" matInput placeholder="Psycho"
                               autocomplete="off">
                        <mat-icon matSuffix>subject</mat-icon>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Avatar</mat-label>
                        <input maxlength="100" name="avatar" [(ngModel)]="user.avatar" type="url" matInput
                               placeholder="https://jugacu.es/s/awesome.png" autocomplete="off"
                               spellcheck="false">
                        <button [disabled]="uploading" mat-icon-button matSuffix (click)="uploadToImgur($event)">
                            <mat-icon>add_photo_alternate</mat-icon>
                        </button>
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                        <mat-label>Password</mat-label>
                        <input name="password" [(ngModel)]="user.password" matInput [type]="hide ? 'password' : 'text'">
                        <button mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'"
                                [attr.aria-pressed]="hide">
                            <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                        </button>
                    </mat-form-field>

                    <button mat-flat-button color="accent" [disabled]="saving"
                            (click)="saveUser()">{{saving ? 'Saving' : 'Save'}}</button>
                </form>
            </div>
        </div>
        <div class="col-12" *ngIf="!loading">
            <mat-divider></mat-divider>
            <div class="security">
                <div class="label">
                    Roles
                </div>
                <div class="content">
                    <app-role [loading]="!rolesReady" (OnAdd)="onRoleAdded($event)" (OnRemove)="onRoleRemoved($event)" [roles]="user.roles"></app-role>
                </div>
            </div>
            <div class="security">
                <div class="label">
                    Permissions
                </div>
                <div class="content">
                    <app-permission [loading]="!permissionsReady" (OnAdd)="onPermissionAdded($event)" (OnRemove)="onPermissionRemoved($event)" [permissions]="user.permissions"></app-permission>
                </div>
            </div>
        </div>
    </div>
</div>
